module.exports = __webpack_public_path__ + "img/Group 1059five.75bea41c.png";